import { useCallback } from 'react';

import { useNavigate } from 'react-router';

import { AppModel } from '../../../../../modules/Apps';
import { useConfirmationDialog } from '../../../../common/ConfirmationDialog';
import { useAppsTableContext } from '../../AppsTableContext';

export const useAppsTableActions = (app: AppModel) => {
  const navigate = useNavigate();

  const {
    handleClose: handleCloseActivateDialog,
    handleOpen: handleOpenActivateDialog,
    isOpen: isOpenActivateDialog,
  } = useConfirmationDialog();

  const {
    handleClose: handleCloseDeactivateDialog,
    handleOpen: handleOpenDeactivateDialog,
    isOpen: isOpenDeactivateDialog,
  } = useConfirmationDialog();

  const {
    handleClose: handleCloseDeleteDialog,
    handleOpen: handleOpenDeleteDialog,
    isOpen: isOpenDeleteDialog,
  } = useConfirmationDialog();

  const { createAppDrawerState, editAppDrawerState, viewAppDrawerState, setEditingApp } =
    useAppsTableContext();

  const openCreateAppDrawer = useCallback(
    () => createAppDrawerState.show(),
    [createAppDrawerState],
  );

  const openEditAppDrawer = useCallback(
    (app: AppModel) => () => {
      setEditingApp(app);
      editAppDrawerState.show();
    },
    [editAppDrawerState, setEditingApp],
  );

  const openViewAppDrawer = useCallback(
    (app: AppModel) => () => {
      setEditingApp(app);
      viewAppDrawerState.show();
    },
    [viewAppDrawerState, setEditingApp],
  );

  const handleNavigateToScopes = useCallback(() => {
    navigate(`/apps/${app.appId}/scopes`);
  }, [app.appId, navigate]);

  const handleNavigateToTargets = useCallback(() => {
    navigate(`/apps/${app.appId}/targets`);
  }, [app.appId, navigate]);

  return {
    isOpenActivateDialog,
    handleOpenActivateDialog,
    handleCloseActivateDialog,
    isOpenDeactivateDialog,
    handleOpenDeactivateDialog,
    handleCloseDeactivateDialog,
    isOpenDeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    openCreateAppDrawer,
    openEditAppDrawer,
    handleNavigateToScopes,
    handleNavigateToTargets,
    openViewAppDrawer,
  };
};
